// extracted by mini-css-extract-plugin
module.exports = {"content":"DesktopDrawer_content__Rem0w","active":"DesktopDrawer_active__Tigid"};